export const SEARCH_CONTRACTS = {
    COLLECTION: {
        url: '/merchantContractsFromProvider',
        queryKey: 'getSearchContracts'
    },
    DIRECT_PROVIDER_COLLECTION: {
        url: '/merchantContractsFromDirectProvider',
        queryKey: 'getContractsFromProvider'
    },
    EXPORT: {
        url: '/merchantContractsFromProvider/export'
    }
};